export const getChiantiClassicoData = () => ({
  name: "Chianti Classico",
  country: "Italie",
  region: "Toscane",
  description: "Chianti Classico est le cœur historique de la Toscane, produisant les vins rouges les plus prestigieux d'Italie avec le cépage Sangiovese.",
  type: "subregion",
  mapAreas: [
    { region: "Chianti Classico", x: 48, y: 42, color: "#4B164C", size: 5 }
  ],
  statistics: {
    totalArea: "7,200 ha",
    production: "250,000 hl",
    wineries: "350+ domaines",
    villages: "9 communes historiques",
    exportPercentage: "75%"
  },
  characteristics: {
    climate: "Climat méditerranéen tempéré, étés chauds et secs",
    soil: "Sols argilo-calcaires, galestro, albarese",
    viticulture: "Vendanges manuelles, cépages autochtones, DOCG stricte"
  },
  wineStyles: {
    red: "Rouges élégants et structurés, tannins fermes, notes de cerise et d'épices"
  },
  history: "Chianti Classico est la plus ancienne appellation d'Italie, créée en 1716. Le coq noir est le symbole de la région.",
  foodPairing: "Bistecca alla fiorentina, pâtes toscanes, fromages pecorino, charcuteries",
  grapeVarieties: [
    {
      name: "Sangiovese",
      percentage: "80%",
      description: "Cépage roi de la Toscane, produisant des vins élégants et structurés",
      characteristics: "Élégant, tanins fermes, notes de cerise et d'épices",
      wineStyles: "Sec, moyen-corps, tannique"
    },
    {
      name: "Canaiolo",
      percentage: "10%",
      description: "Cépage d'assemblage traditionnel, apportant douceur",
      characteristics: "Doux, fruité, tanins soyeux",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Colorino",
      percentage: "5%",
      description: "Cépage teinturier, apportant couleur et structure",
      characteristics: "Coloré, structuré, tanins fermes",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Malvasia Nera",
      percentage: "3%",
      description: "Cépage d'assemblage, apportant aromatique",
      characteristics: "Aromatique, notes florales, structure légère",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Trebbiano",
      percentage: "2%",
      description: "Cépage blanc pour les vins blancs",
      characteristics: "Sec, neutre, acidité vive",
      wineStyles: "Sec, léger, neutre"
    }
  ]
}); 